export default {
  'Extract audio': 'Audio uitpakken',
  'Mute': 'Dempen',
  'Split video and audio': 'Video en audio splitsen',
}